<script setup lang="ts">
defineProps({
  routeName: {
    type: String,
    required: true
  },
  isFavorite: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["toggle-favorite"]);

function handleFavoriteClick(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();
  emit("toggle-favorite");
}
</script>

<template>
  <v-card
    class="report-card d-flex flex-column pa-5 bg-indigo-lighten-5"
    height="100%"
    min-height="350px"
    flat
  >
    <!-- Top row with icon and heart -->
    <div class="d-flex justify-space-between align-start pa-4 pb-0">
      <div class="d-inline">
        <v-icon color="indigo-darken-2" size="32">
          <slot name="icon" />
        </v-icon>
      </div>
      <v-icon
        :color="isFavorite ? 'red' : 'black'"
        :class="['favorite-heart', isFavorite ? 'favorite-active' : '']"
        @click="handleFavoriteClick"
        size="24"
      >
        {{ isFavorite ? 'fas fa-heart' : 'fas fa-heart' }}
      </v-icon>
    </div>

    <!-- Center content area -->
    <div class="flex-grow-1 d-flex flex-column justify-center align-center px-4 text-center">
      <h2 class="text-h4 font-weight-bold mb-4" style="color: #4c51bf;">
        <slot name="title" />
      </h2>
      <div class="text-body-1 text-grey-darken-1 mb-6">
        <slot name="description" />
      </div>
    </div>

    <!-- Bottom button -->
    <div class="pa-4 pt-0">
      <v-btn
        :to="`/insights/${routeName}`"
        color="indigo"
        variant="flat"
        size="large"
        block
        rounded="pill"
        class="text-white font-weight-bold"
      >
        Run Report
        <v-icon class="ml-2" size="20">fas fa-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.favorite-heart {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.favorite-heart:hover {
  transform: scale(1.2);
}

.favorite-active {
  transform: scale(1.1);
}

.report-card {
  position: relative;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.15);
  transition: all 0.3s ease;
}

.report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.2);
}
</style>
